import { BehaviorSubject, Observable } from 'rxjs';

type LoadingState = {
    readonly loading: boolean;
    readonly topLoadingId?: string;
};

class LoadingHelper {
    private _state: BehaviorSubject<LoadingState> = new BehaviorSubject({ loading: false } as LoadingState);
    state: Observable<LoadingState> = this._state.asObservable();

    private queue: string[] = [];

    setLoading(loadingId = 'default') {
        this.fixLoading(loadingId);
        let hot = true;
        return {
            off: () => {
                if (hot) {
                    this.stopLoading(loadingId);
                    hot = false;
                }
            },
        };
    }

    fixLoading(loadingId: string) {
        this.queue.unshift(loadingId);
        this.updateStore();
    }

    private stopLoading(loadingId = 'default') {
        const index = this.queue.indexOf(loadingId);
        this.queue.splice(index, 1);
        this.updateStore();
    }

    private updateStore() {
        const newState: LoadingState = {
            loading: !!this.queue.length,
            topLoadingId: this.queue[0],
        };
        this._state.next(newState);
    }
}

export const loadingHelper = new LoadingHelper();
